import React from "react";
import "./Map.css";

export default function BengaluruMap() {
  return (
    <section className="bloremap-wrapper">
      <div className="bloremap-container">
        <iframe
  title="sreenathji-enterprises-map"
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.843342226473!2d77.55656327358919!3d12.981869814656054!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae3ded7da78e3b%3A0xd9f16a1fbe549b3b!2sSreenathji%20Enterprises!5e0!3m2!1sen!2sin!4v1758102495661!5m2!1sen!2sin"
  width="100%"
  height="450"
  style={{ border: 0 }}
  allowFullScreen
  loading="lazy"
  referrerPolicy="no-referrer-when-downgrade"
/>

      </div>
    </section>
  );
}
